var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 6.94282C14.8571 4.14469 12.0076 1.51426 8 1.51426C3.99236 1.51426 1.14286 4.14469 1.14286 6.94282C1.14286 9.74096 3.99236 12.3714 8 12.3714V13.5142C3.58172 13.5142 0 10.5721 0 6.94282C0 3.31353 3.58172 0.371399 8 0.371399C12.4183 0.371399 16 3.31353 16 6.94282C16 8.18169 15.5827 9.3405 14.8571 10.3295C14.4652 10.8639 15.4286 12.9428 15.1429 13.5142C14.5518 13.963 12.1639 12.595 11.4286 12.882C10.3894 13.2875 9.22695 13.5142 8 13.5142V12.3714C9.08638 12.3714 10.1081 12.1705 11.0134 11.8173L11.1311 11.7765C11.4043 11.6937 11.6643 11.6922 11.8504 11.7045C12.0774 11.7196 12.3033 11.7636 12.5033 11.8117C12.8964 11.9062 13.3372 12.0551 13.6959 12.1727C13.7523 12.1912 13.8075 12.2075 13.8605 12.2246C13.8564 12.2073 13.8524 12.1894 13.8482 12.1716C13.7726 11.853 13.6803 11.4576 13.6406 11.0974C13.6205 10.9149 13.6083 10.697 13.6323 10.4741C13.6552 10.2607 13.7213 9.94625 13.9358 9.65376L14.0441 9.5003C14.5706 8.72615 14.8571 7.85553 14.8571 6.94282Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkBubble);
export default __webpack_public_path__ + "static/media/talkBubble.3b88bd4fe06b982d772617302f19e1c9.svg";
export { ForwardRef as ReactComponent };